









































import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
  i18n: {
    messages: {
      en: {
        Help: {
          Help: 'Help - information',
        },
      },
      nb: {
        Help: {
          Help: 'Hjelp - informasjon',
        },
      },
    },
  },
})
export default class SHelp extends Vue {
  @Prop(String) public content?: string;
  @Prop(String) public name!: string;
  @Prop(Number) public id?: number;
  @Prop(HTMLElement) public element?: HTMLElement;
  public showHelp = false;
}
